(() => {
  const openPreferences = () => {
    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
      return true;
    }

    if (window.Shopify?.customerPrivacy?.showPreferences) {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }

    return false;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-wh-cookie-preferences]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      if (openPreferences()) {
        event.preventDefault();
        return;
      }
    } catch {
      return; // The policy link remains available if the preference API fails.
    }

    if (window.Shopify?.loadFeatures) {
      event.preventDefault();
      let finished = false;
      const fallback = () => {
        if (finished) return;
        finished = true;
        window.location.assign(link.href);
      };
      const timeout = window.setTimeout(fallback, 1500);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          if (finished) return;
          window.clearTimeout(timeout);
          try {
            if (openPreferences()) { finished = true; return; }
          } catch { /* Continue to the policy. */ }
          fallback();
        });
      } catch {
        window.clearTimeout(timeout);
        fallback();
      }
    }
  });
})();
